import { type ComponentOverrides } from "theme/theme.types";

/** `breadcrumbs/spacing`: one distance between every crumb and separator. */
export const BREADCRUMBS_SPACING = 0.5;

/**
 * MUI's root is a `Typography` at `body1`, painted `text.secondary`; Figma's separators keep that colour
 * at `body2`. MUI spaces separators with an 8px margin each side, which the gap replaces.
 */
export const MuiBreadcrumbs: ComponentOverrides["MuiBreadcrumbs"] = {
  styleOverrides: {
    root: ({ theme }) => theme.typography.body2,
    ol: ({ theme }) => ({ gap: theme.spacing(BREADCRUMBS_SPACING) }),
    separator: { marginLeft: 0, marginRight: 0 },
  },
};
